import { configureStore } from "@reduxjs/toolkit";

import drawerSlice from "./slices/drawer.slice";
import userSlice from "./slices/user.slice";
import loginSlice from "./slices/login.slice";
import monthSlice from "./slices/month.slice";
import searchParamsSlice from "./slices/searchParams.slice";
import isBrowserSlice from "./slices/isBrowser.slice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const store = configureStore({
  reducer: {
    login: loginSlice,
    user: userSlice,
    drawer: drawerSlice,
    monthPrices: monthSlice,
    searchParams: searchParamsSlice,
    isBrowser: isBrowserSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
